import Vue from 'vue';
import App from './App';
import router from './router';
import VueResource from 'vue-resource'
// import './assets/css/global.scss';
import wsComponent from './components/index.js'
import storage from './utils/storage'
import anime from 'animejs'
import request from '@/utils/request.js'
import api from '@/utils/api.js'
import ga from '@/utils/ga'
import './directives'
Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(wsComponent);
/* eslint-disable no-new */
window.VM = new Vue({
  el: '#app',
  router,
  render: h => h(App),
})

Vue.prototype.$storage = storage
Vue.prototype.$anime = anime
Vue.prototype.$request = request
Vue.prototype.$api = api
Vue.prototype.ga = ga
// const httpLockArr = {} //请求锁，避免同一条请求重复发送
let requestUrls= {
  requesting:false,
  responsed:false
}
let requestUrl = []
// Vue.http.options.timeout = 10000;
// 请求拦截器
Vue.http.interceptors.push((request,next)=>{
  if(requestUrls.requesting&&requestUrls.responsed){
    requestUrls= {
      requesting:false,
      responsed:false
    }
  }
  requestUrls.requesting=true
  requestUrl.push(request.url)

  // console.log(requestUrls)
  // console.log(requestUrl)

  if(requestUrls.requesting && !requestUrls.responsed && requestUrl.length>1){
      // console.log('has requesting')
    return Promise.reject({
      type:'repeat',
      msg:'TOAST_OPERATE_BUSY'
    })
  }
  else{
    // let timeout = setTimeout(()=>{
    //   // if(request.onTimeout){
    //     console.log('请求超时啦。。。。')
    //     // request.onTimeout(request);
    //     request.abort();
    //   // }
    // },5000);

    next((Response)=>{
      // clearTimeout(timeout)
      requestUrls.responsed = true
      requestUrl=[]
      return Response
    })
  }
// 只能过滤重复请求
// let requestExist = httpLockArr.hasOwnProperty(request.url)
//   let requestHasResponse = httpLockArr[request.url]
  // if(requesting){
  //   console.log('repest')
  //   return Promise.reject({
  //     type:'repeat',
  //     msg:'unuseful request'
  //   })
  // }else{
  //   if(!requestUrls.requesting && !requestUrls.responsed ){
  //     console.log('has requesting')
  //   return Promise.reject({
  //     type:'repeat',
  //     msg:'unuseful request'
  //   })
  //   }
  //   else{
  //     requestUrls.requesting = true
  //     next((Response)=>{
  //       requestUrls.set(request.url,true)
  //       requestUrls.responsed = true
  //       return Response
  //     })
  //   }
  // }
  // if(!first&&haveEmptyResponse){
  //   console.log('dsadas')
  //   return Promise.reject({
  //         type:'repeat',
  //         msg:'unuseful request'
  //       })
  //  }else{
  //    console.log('res')
  //   next((Response)=>{
  //     requestUrls.set(request.url,true)
  //     console.log(requestUrls)
  //     return Response
  //   })
  // }
  // if (requestExist&&!requestHasResponse) {
  //   return Promise.reject({
  //     type:'repeat',
  //     msg:'repeat request'
  //   })
  // }else{
  //   httpLockArr[request.url] = null
  //   next((Response)=>{
  //     // VM.$wsLoading.hide();
  //     httpLockArr[request.url] = true
  //     return Response
  //   })
  // }
})


// WEBPACK FOOTER //
// ./src/main.js